<template>
  <modal
    title="Export Your Contact"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="py-6">
      <p class="text-sm">
        You are about to export your contact register. Note that the File Format
        is CSV.
      </p>
    </div>

    <div class="actions flex justify-between">
      <div class="cursor-pointer" @click="closeModal">
        <p>Cancel</p>
      </div>
      <div>
        <primary-button
          buttonText="Export"
          :loading="loading"
          @click="exportContacts"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import FileDownload from "js-file-download";

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    async exportContacts() {
      this.loading = true;
      try {
        const response = await this.$_downloadContact();
        console.log(response);
        this.closeModal();
        FileDownload(response.data, "contacts.csv");
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
